module.exports = __webpack_public_path__ + "assets/maestro-39be3f.svg";